export default function Footer() {
  return (
   
      <div className="bg-[#7E42FF] py-8 mt-20">
        <div className=" text-white m-auto text-center max-[600px]:text-sm font-bold">
          <h2 dir="rtl">
            تمامی حقوق مادی و معنوی این سایت متعلق به daniibtc است
          </h2>
        </div>
      </div>
    
  );
}
